var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 30.6667H30.6667V34.5H15.3334V30.6667ZM15.3334 23H30.6667V26.8334H15.3334V23ZM26.8334 3.83337H11.5C9.39169 3.83337 7.66669 5.55837 7.66669 7.66671V38.3334C7.66669 40.4417 9.37252 42.1667 11.4809 42.1667H34.5C36.6084 42.1667 38.3334 40.4417 38.3334 38.3334V15.3334L26.8334 3.83337ZM34.5 38.3334H11.5V7.66671H24.9167V17.25H34.5V38.3334Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 38.3334,
    y1: 14.3858,
    x2: 7.6093,
    y2: 15.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5134B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F34D21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.32c0e02967c65e0109555ce67d8892ff.svg";
export { ForwardRef as ReactComponent };